<mat-expansion-panel [expanded]="false" [disabled]="energyUtility">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6">
        <h6>{{ stepTitle }}</h6>
      </div>
      <div class="col-md-6" *ngIf="siteId !== ''">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form
    [formGroup]="formData"
    #formDirective="ngForm"
    (ngSubmit)="submit()"
    novalidate
  >
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right">Create New Group</mat-label>
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>-- Yes / No --</mat-label>
            <mat-select
              [(ngModel)]="model.createNewGroup"
              formControlName="createNewGroupCtr"
              (ngModelChange)="onChangeNewGroup()"
              matInput
            >
              <mat-option>-- Yes / No --</mat-option>
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6" *ngIf="model.createNewGroup === 'false'">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Group<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>-- Choose Group --</mat-label>
            <mat-select
              [(ngModel)]="selectedGroup"
              formControlName="groupCtr"
              matInput
            >
              <mat-option>-- Choose Group --</mat-option>
              <mat-option *ngFor="let item of groups" [value]="item">{{
                item.groupName
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('groupCtr', 'required')"
              >Please choose group</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6" *ngIf="model.createNewGroup === 'true'">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Group Name <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              [(ngModel)]="model.groupname"
              matInput
              placeholder="Group Name"
              formControlName="groupNameCtr"
              required
              matInput
            />
            <mat-error *ngIf="isFieldHasError('groupNameCtr', 'required')"
              >This field is required.</mat-error
            >
            <mat-error *ngIf="isFieldHasError('groupNameCtr', 'maxlength')">
              Please provide comment up to 250 Characters.
            </mat-error>
            <mat-error *ngIf="isFieldHasError('groupNameCtr', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-2">
          <mat-label class="label-input pull-right"
            >Choose Load <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>-- Select --</mat-label>
            <mat-select
              [(ngModel)]="model.loadId"
              formControlName="loadRIdCtr"
              matInput
              [disabled]="
                model.createNewGroup === undefined ||
                model.createNewGroup === ''
              "
            >
              <mat-option>-- Select --</mat-option>
              <mat-option
                *ngFor="let item of loadDataOfSites"
                [value]="item.loadId"
                >{{ item.name }} ---- {{ item.loadId }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="isFieldHasError('loadRIdCtr', 'required')"
              >Please choose load</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-md-2">
          <button
            id="addLoadbtn"
            class="mat-raised-button"
            (click)="onAddNewLoad($event)"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="add icon"
                class="bosch-ic-add"
                style="width: max-content"
              ></mat-icon>
            </span>
            Add New Load
          </button>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 5px">
      <div class="col-md-6">
        <div class="col-md-4">&nbsp;</div>
        <div class="col-md-8">
          <button
            class="mat-raised-button"
            id="addGroupbtn"
            type="submit"
            [disabled]="
              model.createNewGroup === undefined ||
              model.createNewGroup === '' ||
              !formData.valid
            "
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="add icon"
                class="bosch-ic-add"
                style="width: max-content"
              ></mat-icon>
            </span>
            Add Group
          </button>
        </div>
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-responsive">
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">Group</th>
              <th scope="col">Load</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let group of groups; let $index = index">
              <td>
                {{ group.groupName }}
              </td>
              <td>
                <div *ngFor="let load of group.loads">{{ load.name }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</mat-expansion-panel>

<!-- Water Report Grouping Details -->
<mat-expansion-panel [expanded]="false" [disabled]="waterUtility">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <h6>{{ stepTitleForWater }}</h6>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" *ngIf="siteId !== ''">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="formWaterGroup" novalidate>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Create New Group <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Yes / No --</mat-label>
            <mat-select formControlName="createNewGroupCtr">
              <mat-option>-- Yes / No --</mat-option>
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="formWaterGroup.get('createNewGroupCtr').value === 'false'"
      >
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Group<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Choose Group --</mat-label>
            <mat-select formControlName="groupId">
              <mat-option>-- Choose Group --</mat-option>
              <mat-option *ngFor="let item of waterListData" [value]="item">{{
                item.groupName
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('groupId', 'required')"
              >Please choose group</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="formWaterGroup.get('createNewGroupCtr').value === 'true'"
      >
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Group Name <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <input
              matInput
              placeholder="Group Name"
              formControlName="groupName"
              required
              matInput
            />
            <mat-error *ngIf="hasError('groupName', 'required')"
              >This field is required.</mat-error
            >
            <mat-error *ngIf="hasError('groupName', 'maxlength')">
              Please provide comment up to 250 Characters.
            </mat-error>
            <mat-error *ngIf="hasError('groupName', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
          <mat-label class="label-input pull-right"
            >Choose Load <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Select --</mat-label>
            <mat-select formControlName="loads">
              <mat-option>-- Select --</mat-option>
              <mat-option *ngFor="let item of waterLoads" [value]="item"
                >{{ item.name }} ---- {{ item.loadId }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="hasError('loads', 'required')"
              >Please choose load</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 5px">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">&nbsp;</div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <button
            class="mat-raised-button"
            id="addGroupbtn"
            (click)="submitWaterDetails()"
            type="submit"
            [disabled]="!formWaterGroup.valid"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="add icon"
                class="bosch-ic-add"
                style="width: max-content"
              >
              </mat-icon>
            </span>
            Add Group
          </button>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"></div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="table-responsive">
          <table class="table">
            <caption></caption>
            <thead>
              <tr>
                <th scope="col">Group</th>
                <th scope="col">Load</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of waterListData">
                <td>
                  <div *ngIf="item && item.groupName">{{ item.groupName }}</div>
                </td>
                <td>
                  <div *ngIf="item && item.loads">
                    <div *ngFor="let load of item.loads">{{ load.name }}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</mat-expansion-panel>

<!-- Gas Report Grouping Details -->
<mat-expansion-panel [expanded]="false" [disabled]="gasUtility">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <h6>{{ stepTitleForGas }}</h6>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" *ngIf="siteId !== ''">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="formGasGroup" novalidate>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Create New Group <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Yes / No --</mat-label>
            <mat-select formControlName="createNewGroupCtr">
              <mat-option>-- Yes / No --</mat-option>
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="formGasGroup.get('createNewGroupCtr').value === 'false'"
      >
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Group<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Choose Group --</mat-label>
            <mat-select formControlName="groupId">
              <mat-option>-- Choose Group --</mat-option>
              <mat-option *ngFor="let item of gasListData" [value]="item">{{
                item.groupName
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('groupId', 'required')"
              >Please choose group</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="formGasGroup.get('createNewGroupCtr').value === 'true'"
      >
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Group Name <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <input
              matInput
              placeholder="Group Name"
              formControlName="groupName"
              required
              matInput
            />
            <mat-error *ngIf="hasError('groupName', 'required')"
              >This field is required.</mat-error
            >
            <mat-error *ngIf="hasError('groupName', 'maxlength')">
              Please provide comment up to 250 Characters.
            </mat-error>
            <mat-error *ngIf="hasError('groupName', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
          <mat-label class="label-input pull-right"
            >Choose Load <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Select --</mat-label>
            <mat-select formControlName="loads">
              <mat-option>-- Select --</mat-option>
              <mat-option *ngFor="let item of gasLoads" [value]="item"
                >{{ item.name }} ---- {{ item.loadId }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="hasError('loads', 'required')"
              >Please choose load</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 5px">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">&nbsp;</div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <button
            class="mat-raised-button"
            id="addGroupbtn"
            (click)="submitGasDetails()"
            type="submit"
            [disabled]="!formGasGroup.valid"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="add icon"
                class="bosch-ic-add"
                style="width: max-content"
              >
              </mat-icon>
            </span>
            Add Group
          </button>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"></div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="table-responsive">
          <table class="table">
            <caption></caption>
            <thead>
              <tr>
                <th scope="col">Group</th>
                <th scope="col">Load</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of gasListData">
                <td>
                  <div *ngIf="item && item.groupName">{{ item.groupName }}</div>
                </td>
                <td>
                  <div *ngIf="item && item.loads">
                    <div *ngFor="let load of item.loads">{{ load.name }}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</mat-expansion-panel>

<!-- Air Report Grouping Details -->
<mat-expansion-panel [expanded]="false" [disabled]="airUtility">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <h6>{{ stepTitleForAir }}</h6>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" *ngIf="siteId !== ''">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="formAirGroup" novalidate>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Create New Group <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Yes / No --</mat-label>
            <mat-select formControlName="createNewGroupCtr">
              <mat-option>-- Yes / No --</mat-option>
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="formAirGroup.get('createNewGroupCtr').value === 'false'"
      >
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Group<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Choose Group --</mat-label>
            <mat-select formControlName="groupId">
              <mat-option>-- Choose Group --</mat-option>
              <mat-option *ngFor="let item of airListData" [value]="item">{{
                item.groupName
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('groupId', 'required')"
              >Please choose group</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
        *ngIf="formAirGroup.get('createNewGroupCtr').value === 'true'"
      >
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Group Name <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <input
              matInput
              placeholder="Group Name"
              formControlName="groupName"
              required
              matInput
            />
            <mat-error *ngIf="hasError('groupName', 'required')"
              >This field is required.</mat-error
            >
            <mat-error *ngIf="hasError('groupName', 'maxlength')">
              Please provide comment up to 250 Characters.
            </mat-error>
            <mat-error *ngIf="hasError('groupName', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
          <mat-label class="label-input pull-right"
            >Choose Load <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>-- Select --</mat-label>
            <mat-select formControlName="loads">
              <mat-option>-- Select --</mat-option>
              <mat-option *ngFor="let item of airLoads" [value]="item"
                >{{ item.name }} ---- {{ item.loadId }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="hasError('loads', 'required')"
              >Please choose load</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 5px">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">&nbsp;</div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <button
            class="mat-raised-button"
            id="addGroupbtn"
            (click)="submitAirDetails()"
            type="submit"
            [disabled]="!formAirGroup.valid"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="add icon"
                class="bosch-ic-add"
                style="width: max-content"
              >
              </mat-icon>
            </span>
            Add Group
          </button>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"></div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="table-responsive">
          <table class="table">
            <caption></caption>
            <thead>
              <tr>
                <th scope="col">Group</th>
                <th scope="col">Load</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of airListData">
                <td>
                  <div *ngIf="item && item.groupName">{{ item.groupName }}</div>
                </td>
                <td>
                  <div *ngIf="item && item.loads">
                    <div *ngFor="let load of item.loads">{{ load.name }}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</mat-expansion-panel>

<!-- Set Target for Functional Report -->
<mat-expansion-panel [expanded]="false">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <h6>Configure Target for Report</h6>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" *ngIf="siteId !== ''">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="formConfigTarget" novalidate>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Select KPI Utility<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-label>Choose Utility</mat-label>
            <mat-select
              [(ngModel)]="targetModel.kpiUtility"
              formControlName="kpiUtilityCtr"
              (selectionChange)="getGroupsBasedOnUtility($event)"
            >
              <mat-option
                *ngFor="let utility of siteModel.configuredKpiUtilities"
                [value]="utility"
                >{{ utility }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="isTargetFieldHasError('kpiUtilityCtr', 'required')"
              >This field is required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>

      <!-- Select group -->
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Select Group :<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <mat-select
              [(ngModel)]="targetModel.group"
              formControlName="groupWiseTargetCtr"
              required
            >
              <mat-option
                *ngFor="let item of targetGroup"
                [value]="item.groupName"
                >{{ item.groupName }}</mat-option
              >
            </mat-select>
            <mat-error
              *ngIf="isTargetFieldHasError('groupWiseTargetCtr', 'required')"
              >This field is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Select Date -->
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Select Date: <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker1"
              [formControl]="startDateCtr"
              placeholder="Select date"
              (dateChange)="validateDate()"
              [max]="max"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #picker1
              startView="multi-year"
              (yearSelected)="chosenYearHandler($event)"
              (monthSelected)="chosenMonthHandler($event, picker1)"
            ></mat-datepicker>
            <mat-error *ngIf="startDateCtr.invalid || !isValidStartDate"
              >Invalid Date</mat-error
            >
          </mat-form-field>
        </div>
      </div>

      <!-- Enter Target -->
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input pull-right"
            >Set Target: <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
          <mat-form-field>
            <input
              type="number"
              matInput
              formControlName="targetCtr"
              placeholder="Target"
              [(ngModel)]="targetModel.target"
            />
            <mat-error *ngIf="isTargetFieldHasError('targetCtr', 'required')"
              >This field is required.
            </mat-error>
            <mat-error *ngIf="isTargetFieldHasError('targetCtr', 'pattern')"
              >Please enter valid Value.
            </mat-error>
            <mat-error *ngIf="isTargetFieldHasError('targetCtr', 'whitespace')"
              >Please enter valid Value.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        style="text-align: center"
      >
        <button
          bciprimarybutton
          class="button-primary"
          type="submit"
          id="submitTargetForm"
          (click)="submitTargetForm()"
          [disabled]="!formConfigTarget.valid || startDateCtr.invalid"
        >
          Add Target</button
        >&nbsp;
        <button
          bciprimarybutton
          class="button-primary"
          type="reset"
          id="resetTargetForm"
          (click)="resetTargetForm()"
        >
          Reset
        </button>
      </div>
    </div>

    <!--Fetch Report Target table-->
    <br />

    <mat-table #table [dataSource]="targetFormDataSource">
      <ng-container matColumnDef="kpiUtility">
        <mat-header-cell *matHeaderCellDef> KPI Utility</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.kpiUtility }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="group">
        <mat-header-cell *matHeaderCellDef>Group</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.group }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.date }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="target">
        <mat-header-cell *matHeaderCellDef>Target</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.target }}</mat-cell>
      </ng-container>
      <mat-header-row
        *matHeaderRowDef="displayedColumnsTarget"
      ></mat-header-row>
      <mat-row
        *matRowDef="let element; columns: displayedColumnsTarget"
      ></mat-row>
    </mat-table>
    <mat-paginator
      #targetpaginator
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 20]"
    >
    </mat-paginator>
  </form>
</mat-expansion-panel>

<br />
<!-- Previous & Next BUtton  -->
<div class="row">
  <div class="col-md-12" style="text-align: center">
    <button
      bciprimarybutton
      class="button-primary"
      id="previousbtn"
      (click)="goPrevious($event)"
    >
      <span>
        <mat-icon
          aria-hidden="false"
          aria-label="weather icon"
          class="bosch-ic-arrow-left-frame"
          style="width: max-content"
        ></mat-icon> </span
      >Previous
    </button>
    &nbsp; &nbsp;
    <button
      bciprimarybutton
      class="button-primary"
      id="nextbtn"
      (click)="goTo($event)"
    >
      Next
      <span>
        <mat-icon
          aria-hidden="false"
          aria-label="weather icon"
          class="bosch-ic-arrow-right-frame"
          style="width: max-content"
        ></mat-icon>
      </span>
    </button>
  </div>
</div>
